import { render, staticRenderFns } from "./accountingSettings.vue?vue&type=template&id=0706ab60&scoped=true&"
import script from "./accountingSettings.vue?vue&type=script&lang=js&"
export * from "./accountingSettings.vue?vue&type=script&lang=js&"
import style0 from "./accountingSettings.vue?vue&type=style&index=0&id=0706ab60&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0706ab60",
  null
  
)

export default component.exports